import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { hudlUserIdAtom } from '@/atoms/queries/user';
import { RecentVisit } from '@/types/recentlyVisited';
import { addRecentVisit } from '@/utils/recentlyVisited';

// Versioned so a later change to the stored shape can start from a clean key instead of migrating.
export const RECENTLY_VISITED_STORAGE_KEY = 'homeRecentlyVisited:v1';

// One key for every user's history, because atomWithStorage fixes its key before the user is known.
export const recentlyVisitedByUserAtom = atomWithStorage<Record<string, RecentVisit[]>>(
  RECENTLY_VISITED_STORAGE_KEY,
  {},
  undefined,
  { getOnInit: true },
);

export const recentlyVisitedAtom = atom(async get => {
  const hudlUserId = await get(hudlUserIdAtom);
  return get(recentlyVisitedByUserAtom)[hudlUserId] ?? [];
});

export const addRecentVisitAtom = atom(null, (_get, set, hudlUserId: string, visit: RecentVisit) => {
  set(recentlyVisitedByUserAtom, previous => ({
    ...previous,
    [hudlUserId]: addRecentVisit(previous[hudlUserId] ?? [], visit),
  }));
});
